// https://stackoverflow.com/a/46700791
// TypeScript-friendly for .filer()
export function isNotEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}
